import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function ConfirmEmail({ onAuth }) {
  const [checking, setChecking] = useState(true);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let interval;
    async function checkSession() {
      const { data: { session } } = await supabase.auth.getSession();
      if (session && session.user && session.user.email_confirmed_at) {
        setMessage('Email confirmed! Redirecting...');
        await supabase.from('users').upsert([
          {
            id: session.user.id,
            email: session.user.email,
          }
        ]);
        onAuth(session.user);
        setTimeout(() => navigate('/dashboard'), 1200);
      } else {
        setChecking(false);
      }
    }
    checkSession();
    interval = setInterval(checkSession, 2000);
    return () => clearInterval(interval);
  }, [navigate, onAuth]);

  return (
    <div style={{textAlign:'center', marginTop:40}}>
      <h2>Confirm Your Email</h2>
      <p>We sent a confirmation link to your email. Please check your inbox and click the link to activate your account.</p>
      <p style={{color:'#aaa', fontSize:'0.98em'}}>After confirming, this page will automatically redirect you to your dashboard.</p>
      {checking && <div style={{marginTop:18, color:'#aaa'}}>Checking confirmation status...</div>}
      {message && <div className="message">{message}</div>}
    </div>
  );
} 